export default __webpack_public_path__ + "12d39f247816d7c177b809b72008073c.png";